import { action, observable, computed } from 'mobx';
import moment from 'moment';
import Validator from 'validatorjs';

import {
  getClientInfo,
  getBussinesUnit,
  getCityList,
  getClientOfficer,
  getCountryList,
  getLookupConfig,
  getStaff,
  getStaffAll,
  uploadFileTemplate,
  viewBookingHistory,
  getAllSpecialist,
  getRegisteredSpecialistDetails,
  getRegisteredSpecialists,
} from './service';
// import { formatDate } from '../../../utils/functions';

const INIT_CLIENT = {
  ABN: null,
  AccContact: null,
  AccEmail: null,
  AccPhoneNumber: null,
  ActionCompleted: false,
  ActionNotes: null,
  ActionRequired: false,
  Address: null,
  AppointmentBookingReminderDueDay: 0,
  ApprovedFundingDate: null,
  AssignedToUserFullName: null,
  AssignedToUserId: null,
  CityId: 108,
  ClientAdvisors: null,
  ClientType: 0,
  // ClientType2: 0,
  CommentsFunding: null,
  CompanyBusinessUnit: null,
  CompletedDate: null,
  CorrespondenceAddress: null,
  CorrespondenceCityId: 108,
  CorrespondenceCountryId: 16,
  CorrespondenceDistrict: null,
  CorrespondenceFullAddress: null,
  CorrespondencePostcode: null,
  CountryId: 16,
  District: null,
  DoctorTypesForSearching: null,
  DueDate: null,
  EffectiveMAGDirectEssentialFrom: null,
  EffectiveMAGDirectEssentialTo: null,
  EffectiveMAGDirectExtraFrom: null,
  EffectiveMAGDirectExtraTo: null,
  EffectiveMAGUltimateFrom: moment().format('DD/MM/YYYY'),
  EffectiveMAGUltimateTo: null,
  Email: null,
  EndFundingTerm: null,
  Fax: null,
  FullAddress: null,
  FundingApprovedByEmail: null,
  FundingApprovedById: null,
  FundingApprovedByName: null,
  FundingAttachments: null,
  Id: 0,
  IsDisbursementFunding: false,
  MAGDirectEssentialServiceFees: null,
  MAGDirectEssentialServiceFeesGST: null,
  MAGDirectExtraServiceFees: null,
  MAGDirectExtraServiceFeesGST: null,
  MAGUltimateServiceFees: null,
  MAGUltimateServiceFeesGST: null,
  Name: null,
  OtherClientType: null,
  Postcode: null,
  PrimarySegments: null,
  RDCCaseManagerEmail: null,
  RDCCaseManagerName: null,
  ReportCompletionReminderDueDay: 0,
  ReportDeliveryContact: null,
  SecondarySegments: null,
  StaffId: null,
  StartFundingTerm: null,
  SubscribeToInvoiceReminders: false,
  SubscribeToPromotions: false,
  Telephone: null,
  Website: null,
  // CIR-1295
  IsFAPaymentRequired: false,
  FAApprovedDate: null,
  FAApprovedById: null,
  FAAttachments: null,
};

const VALIDATE_RULES = {
  Name: 'required',
  // ClientType2: 'required',
  ClientType: 'required',
  OtherClientType: 'required',
  Telephone: 'max:10',
  Email: 'email',
  EffectiveMAGDirectEssentialFrom: 'required',
  EffectiveMAGDirectExtraFrom: 'required',
  EffectiveMAGUltimateFrom: 'required',
  CityId: 'required',
  Fax: ['max:10', 'min:6'],
};

const ERROR_MESSAGES = {
  required: 'This field is required',
  email: 'Invalid email address',
  max: {
    string: 'Must be less than or equal to 10 digits',
  },
  min: {
    string: 'Must be more than or equal to 6 digits',
  },
};

const EFFECTIVE_FROM_FIELD_NAME = [
  'EffectiveMAGDirectEssentialFrom',
  'EffectiveMAGDirectExtraFrom',
  'EffectiveMAGUltimateFrom',
];

class AddEditClientStore {
  @observable loading = true;
  @observable loadingUpload = false;
  @observable loadingSave = false;
  @observable loadingCheckDuplicate = false;

  //Data
  @observable clientInfo = INIT_CLIENT;
  @observable businessUnitList = null;
  @observable cityList = null;
  @observable clientOfficerList = null;
  @observable staffList = null;
  @observable staffAllList = null;
  @observable lookupConfig = null;
  @observable countryList = null;
  //Correspondence
  @observable countryCorrespondenceList = null;
  @observable cityCorrespondenceList = null;

  //Error
  @observable errors = {};

  //Modal
  @observable open = false;
  @observable modalParams = {};

  //Modal booking history
  @observable dataBookingHistory = null;
  @observable loadingBookingHistory = true;
  @observable totalBooking = 0;

  @observable sortColumnBookingHistory = 'Request Date';
  @observable sortDirectionBookingHistory = 'ascending';
  @observable sortKeyBookingHistory = 'RequestDate';

  @action handleFetchBookingHistory = () => {
    Promise.all([
      viewBookingHistory(
        this.clientInfo.Id,
        this.sortKeyBookingHistory,
        this.sortDirectionBookingHistory,
      ),
    ]).then(
      action(([dataBooking]) => {
        this.loadingBookingHistory = false;
        this.dataBookingHistory = dataBooking;
        this.totalBooking = dataBooking.sumItem;
      }),
    );
  };

  @action handleSortBooking = ({ sortKey }, { column, direction }) => {
    console.log({ sortKey }, { column, direction });
    this.sortColumnBookingHistory = column;
    this.sortDirectionBookingHistory = direction;
    this.sortKeyBookingHistory = sortKey;
    this.handleFetchBookingHistory();
  };

  //Assign Doctor
  @observable specialistLoading = false;
  @observable registeredSpecialistIds = [];
  @observable specialists = [];
  @observable sumItemSpecialist = 0;
  @observable sumPageSpecialist = 0;
  @observable curPageSpecialist = 1;
  @observable searchSpecialist = '';
  @observable selectedSpecialist = 'All';

  @action handlePageClickSpecialist = page => {
    if (this.selectedSpecialist === 'All') {
      this.curPageSpecialist = page;
      this.specialistLoading = true;

      getAllSpecialist({
        CurPage: page,
        IsSelectionList: true,
        Keyword: this.search,
      }).then(
        action(({ itemList }) => {
          this.specialists = itemList;
          this.specialistLoading = false;
        }),
      );
    }
  };

  @action handleClearSearchSpecialist = () => {
    this.searchSpecialist = '';
    this.handleSearchSpecialist();
  };

  @action handleSearchChange = event => {
    this.searchSpecialist = event.target.value;
  };

  fetchSpecialists = id => {
    return getRegisteredSpecialists(id).then(
      action(({ itemList }) => {
        if (itemList.length !== 0) {
          this.registeredSpecialistIds = itemList;
          this.selectedSpecialist = 'selected';
          return getRegisteredSpecialistDetails(itemList);
        } else {
          this.selectedSpecialist = 'All';
          return getAllSpecialist({
            CurPage: 1,
            IsSelectionList: true,
            Keyword: '',
          });
        }
      }),
    );
  };

  @action handleSearchSpecialist = () => {
    this.specialistLoading = true;

    if (this.selectedSpecialist === 'selected') {
      setTimeout(
        action(() => {
          this.specialistLoading = false;
        }),
        300,
      );
    } else {
      getAllSpecialist({
        CurPage: 1,
        IsSelectionList: true,
        Keyword: this.searchSpecialist,
      }).then(
        action(({ itemList, sumItem, sumPage }) => {
          this.specialists = itemList;
          this.sumItemSpecialist = sumItem;
          this.sumPageSpecialist = sumPage;
          this.curPageSpecialist = 1;
          this.specialistLoading = false;
        }),
      );
    }
  };
  @action handleSelectChangeSpecialist = value => {
    this.selectedSpecialist = value;
    this.specialistLoading = true;

    if (value === 'All') {
      getAllSpecialist({
        CurPage: 1,
        IsSelectionList: true,
        Keyword: this.search,
      }).then(
        action(({ itemList, sumItem, sumPage }) => {
          this.specialists = itemList;
          this.sumItemSpecialist = sumItem;
          this.sumPageSpecialist = sumPage;
          this.curPageSpecialist = 1;
          this.specialistLoading = false;
        }),
      );
    } else {
      getRegisteredSpecialists(this.clientInfo.Id)
        .then(({ itemList }) => getRegisteredSpecialistDetails(itemList))
        .then(
          action(({ itemList, sumPage, sumItem }) => {
            this.specialists = itemList;
            this.sumItemSpecialist = sumItem;
            this.sumPageSpecialist = sumPage;
            this.curPageSpecialist = 1;
            this.specialistLoading = false;
          }),
        );
    }
  };

  /////////////////////////////////////////

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };
  //

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action handleAddError = (fieldName, errorMessage) => {
    this.errors[fieldName] = errorMessage;
  };

  @action fetchAll = clientId => {
    this.loading = true;
    Promise.all([
      getClientInfo(clientId),
      getBussinesUnit(),
      getCityList(),
      getClientOfficer(),
      getStaff(),
      getStaffAll(),
      getLookupConfig(),
      getCountryList(),
      this.fetchSpecialists(clientId),
    ]).then(
      action(
        ([
          clientInfo,
          businessUnitList,
          cityList,
          clientOfficerList,
          staffList,
          staffAllList,
          lookupConfig,
          countryList,
          specialist,
        ]) => {
          this.loading = false;
          this.clientInfo = clientInfo;
          this.countryCorrespondenceList = countryList;
          this.cityCorrespondenceList = cityList;
          this.businessUnitList = businessUnitList;
          this.cityList = cityList;
          this.clientOfficerList = clientOfficerList;
          this.staffList = staffList;
          this.staffAllList = staffAllList;
          this.lookupConfig = lookupConfig;
          this.countryList = countryList;
          this.specialists = specialist.itemList;
          this.sumItemSpecialist = specialist.sumItem;
          this.sumPageSpecialist = specialist.sumPage;
          this.curPageSpecialist = 1;
          this.handleFetchBookingHistory();
        },
      ),
    );
  };

  @action handleValidate = (field, value) => {
    const validation = new Validator(
      { [field]: value },
      { [field]: VALIDATE_RULES[field] },
      ERROR_MESSAGES,
    );

    if (field === 'Fax') {
      const minDigits = new Validator(
        { [field]: value },
        { [field]: VALIDATE_RULES[field][1] },
        ERROR_MESSAGES,
      );
      const maxDigits = new Validator(
        { [field]: value },
        { [field]: VALIDATE_RULES[field][0] },
        ERROR_MESSAGES,
      );
      if (minDigits.passes()) {
        delete this.errors[field];
        if (maxDigits.passes()) {
          delete this.errors[field];
        } else {
          this.errors[field] = maxDigits.errors.first(field);
        }
      } else {
        this.errors[field] = minDigits.errors.first(field);
      }
    } else {
      if (validation.passes()) {
        delete this.errors[field];
      } else {
        this.errors[field] = validation.errors.first(field);
      }
    }
  };

  @action handleChecked = fieldName =>
    action(event => {
      const value = event
        ? event.target
          ? event.target.checked
          : event
        : false;
      this.clientInfo[fieldName] = value;
    });

  @action handleUploadFile = file => {
    this.loadingUpload = true;

    const formData = new FormData();
    formData.append(file.name, file);

    uploadFileTemplate(formData).then(
      action(({ fileList }) => {
        const attachments = this.clientInfo.FAAttachments
          ? JSON.parse(this.clientInfo.FAAttachments)
          : [];
        const attachment = {
          FileName: fileList[0].name,
          Title: fileList[0].title,
          NumberOfPages: fileList[0].numberOfPages,
          Id: attachments.length,
        };

        const newFAAttachments = [...attachments, attachment];
        this.clientInfo.FAAttachments = JSON.stringify(newFAAttachments);
        this.loadingUpload = false;
      }),
    );
  };

  @action initData = () => {
    this.loading = true;
    Promise.all([
      getBussinesUnit(),
      getCityList(),
      getClientOfficer(),
      getStaff(),
      getStaffAll(),
      getLookupConfig(),
      getCountryList(),
    ]).then(
      action(
        ([
          businessUnitList,
          cityList,
          clientOfficerList,
          staffList,
          staffAllList,
          lookupConfig,
          countryList,
        ]) => {
          this.clientInfo = INIT_CLIENT;
          this.businessUnitList = businessUnitList;
          this.cityList = cityList;
          this.clientOfficerList = clientOfficerList;
          this.staffList = staffList;
          this.staffAllList = staffAllList;
          this.countryCorrespondenceList = countryList;
          this.cityCorrespondenceList = cityList;
          this.lookupConfig = lookupConfig;
          this.countryList = countryList;
          this.loading = false;
          this.loadingBookingHistory = false;
        },
      ),
    );
  };

  @action handleDeleteFile = index => {
    const attachments = JSON.parse(this.clientInfo.FAAttachments).filter(
      (_, idx) => idx !== index,
    );
    this.clientInfo.FAAttachments = JSON.stringify(attachments);
  };

  renderErrorFieldName = type => {
    switch (type) {
      case 0:
        return 'EffectiveMAGUltimateFrom';
      case 1:
        return 'EffectiveMAGDirectEssentialFrom';
      case 2:
        return 'EffectiveMAGDirectExtraFrom';
      default:
        return '';
    }
  };

  handleFieldChange = fieldName =>
    action(event => {
      const value = event ? (event.target ? event.target.value : event) : null;
      if (
        fieldName === 'DoctorTypesForSearching' ||
        fieldName === 'PrimarySegments' ||
        fieldName === 'SecondarySegments'
      ) {
        this.clientInfo[fieldName] = value.join();
      } else if (fieldName === 'ClientType2') {
        if (!this.clientInfo[this.renderErrorFieldName(value)]) {
          this.errors[this.renderErrorFieldName(value)] =
            'This field is required';
          EFFECTIVE_FROM_FIELD_NAME.filter(
            i => i !== this.renderErrorFieldName(value),
          ).map(i => delete this.errors[i]);
        }
        this.clientInfo[fieldName] = value;
      } else if (fieldName === 'ClientType') {
        if (value === 5 && !this.clientInfo.OtherClientType) {
          this.errors['OtherClientType'] = 'This field is required';
        } else {
          delete this.errors['OtherClientType'];
        }
        this.clientInfo[fieldName] = value;
      } else if (fieldName === 'ClientAdvisors') {
        const exist = value.map(i => {
          const existStaff = this.clientOfficerList.itemList.find(
            staff => staff.Id === i,
          );
          if (existStaff)
            return {
              fullName: existStaff.FullName,
              id: existStaff.Id,
            };
          return undefined;
        });
        this.clientInfo[fieldName] = exist.filter(i => i !== undefined);
      } else if (fieldName === 'CompanyBusinessUnit') {
        const exist = value.map(i => {
          const existBusinessUnit = JSON.parse(
            this.businessUnitList,
          ).itemList.find(unit => unit.id === i);
          if (existBusinessUnit)
            return {
              title: existBusinessUnit.title,
              id: existBusinessUnit.id,
            };
          return undefined;
        });
        this.clientInfo[fieldName] = exist.filter(i => i !== undefined);
      } else if (fieldName === 'CountryId') {
        Promise.all([getCityList(value)]).then(
          action(([cityList]) => (this.cityList = cityList)),
        );
        this.clientInfo[fieldName] = value;
      } else if (fieldName === 'CorrespondenceCountryId') {
        Promise.all([getCityList(value)]).then(
          action(([cityList]) => (this.cityCorrespondenceList = cityList)),
        );
        this.clientInfo[fieldName] = value;
      } else if (
        fieldName === 'AccPhoneNumber' ||
        fieldName === 'Telephone' ||
        fieldName === 'Fax'
      ) {
        this.clientInfo[fieldName] = value
          .replace(/\D/g, '')
          .replace(/[^\d]/g, '');
      } else {
        this.clientInfo[fieldName] = value;
      }

      if (VALIDATE_RULES[fieldName]) {
        this.handleValidate(fieldName, this.clientInfo[fieldName]);
      }
      if (fieldName === 'CityId' && this.clientInfo.CountryId === 16) {
        this.handleValidate(fieldName, this.clientInfo[fieldName]);
      } else {
        delete this.errors.CityId;
      }
    });

  @action removeError = key => {
    delete this.errors[key];
  };

  @computed get staffs() {
    return this.staffList && this.staffList.itemList
      ? this.staffList.itemList.map(i => ({ text: i.FullName, value: i.Id }))
      : [];
  }

  @action resetStore = () => {
    this.loading = true;
    this.clientInfo = INIT_CLIENT;
    this.errors = {};

    this.dataBookingHistory = null;
    this.loadingBookingHistory = true;
    this.totalBooking = 0;
    this.registeredSpecialistIds = [];

    this.sortColumnBookingHistory = 'Request Date';
    this.sortDirectionBookingHistory = 'ascending';
    this.sortKeyBookingHistory = 'RequestDate';
  };
}

export default new AddEditClientStore();
